import { createSelector } from '@ngrx/store';

import { onlineMenuState } from '../root';

export const getOnlineMenu = createSelector(onlineMenuState, (onlineMenu) => onlineMenu);
